import { UPDATE_PARTITIONS } from '../actions/partitions';
import { LOGOUT } from '../actions/screen';
import { ButtonType } from '../components/Sidebar/constants';

export const getInitialState = () => Object.keys(ButtonType).map((key) => ({ buttonType: ButtonType[key], visible: true }));

/**
 * R-1: согласование сохранённого у пользователя списка разделов с актуальным
 * перечнем ButtonType. У пилотов, обновившихся со старой версии, в state.partitions
 * нет новых кнопок (например, «Сообщения») — они бы не появились в меню.
 * Хелпер дописывает недостающие разделы В КОНЕЦ, сохраняя порядок и видимость уже
 * существующих. Чистая функция, ничего не мутирует.
 */
export const reconcilePartitions = (partitions) => {
    const list = Array.isArray(partitions) ? partitions : Object.values(partitions || {});
    const present = new Set(list.map((item) => item && item.buttonType));
    const missing = Object.keys(ButtonType)
        .map((key) => ButtonType[key])
        .filter((buttonType) => !present.has(buttonType))
        .map((buttonType) => ({ buttonType, visible: true }));

    return missing.length ? [...list, ...missing] : list;
};

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case UPDATE_PARTITIONS: {
            if (action.data) {
                const newState = action.data.map(({ id: buttonType, visible }) => ({ buttonType, visible }));
                return [...newState];
            }

            return state;
        }
        case LOGOUT:
            return [...getInitialState()];
        default:
            return state;
    }
};
